import { CdsContentPanel, CdsDropdownField, CdsForm, CdsInputField, CdsFormModal,CdsErrorModal } from 'clayco-component-library/lib';
import React, { useEffect, useState } from 'react';
import {Row, Col} from 'react-bootstrap';
import * as yup from 'yup';
import Spinner from '../../skills-experience/shared/spinner';
import ApiProvider from '../../../apiProvider';
import { useMsal } from "@azure/msal-react";
import AddressValidationModal from './addressValidationModal';

const Address = ({data}) => {
    const [isDirty, setIsDirty] = useState(false);
    const [model, setModel] = useState(data);
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState(false);
    const [countries] = useState([{"id":"US","name":"United States"},{"id":"AF","name":"Afghanistan"},{"id":"AL","name":"Albania"},{"id":"DZ","name":"Algeria"},{"id":"AS","name":"American Samoa"},{"id":"AD","name":"Andorra"},{"id":"AO","name":"Angola"},{"id":"AI","name":"Anguilla"},{"id":"AQ","name":"Antarctica"},{"id":"AG","name":"Antigua and Barbuda"},{"id":"AR","name":"Argentina"},{"id":"AM","name":"Armenia"},{"id":"AW","name":"Aruba"},{"id":"AU","name":"Australia"},{"id":"AT","name":"Austria"},{"id":"AZ","name":"Azerbaijan"},{"id":"BS","name":"Bahamas"},{"id":"BH","name":"Bahrain"},{"id":"BD","name":"Bangladesh"},{"id":"BB","name":"Barbados"},{"id":"BE","name":"Belgium"},{"id":"BZ","name":"Belize"},{"id":"BJ","name":"Benin"},{"id":"BM","name":"Bermuda"},{"id":"BT","name":"Bhutan"},{"id":"BO","name":"Bolivia"},{"id":"BA","name":"Bosnia and Herzegovina"},{"id":"BW","name":"Botswana"},{"id":"BV","name":"Bouvet Island"},{"id":"BR","name":"Brazil"},{"id":"IO","name":"British Indian Ocean Territory"},{"id":"VG","name":"British Virgin Islands"},{"id":"BN","name":"Brunei"},{"id":"BG","name":"Bulgaria"},{"id":"BF","name":"Burkina Faso"},{"id":"BI","name":"Burundi"},{"id":"BY","name":"Byelorussian SSR"},{"id":"KH","name":"Cambodia"},{"id":"CM","name":"Cameroon"},{"id":"CA","name":"Canada"},{"id":"PQ","name":"Canada"},{"id":"CV","name":"Cape Verde"},{"id":"KY","name":"Cayman Islands"},{"id":"CF","name":"Central African Republic"},{"id":"TD","name":"Chad"},{"id":"CL","name":"Chile"},{"id":"CN","name":"China"},{"id":"CX","name":"Christmas Island"},{"id":"CC","name":"Cocos (Keeling) Islands"},{"id":"CO","name":"Colombia"},{"id":"KM","name":"Comoros"},{"id":"CG","name":"Congo"},{"id":"CK","name":"Cook Islands"},{"id":"CR","name":"Costa Rica"},{"id":"HR","name":"Croatia"},{"id":"CU","name":"Cuba"},{"id":"CY","name":"Cyprus"},{"id":"CZ","name":"Czech Republic"},{"id":"CD","name":"Democratic Republic of Congo"},{"id":"DK","name":"Denmark"},{"id":"DJ","name":"Djibouti"},{"id":"DM","name":"Dominica"},{"id":"DO","name":"Dominican Republic"},{"id":"EC","name":"Ecuador"},{"id":"EG","name":"Egypt"},{"id":"SV","name":"El Salvador"},{"id":"GQ","name":"Equatorial Guinea"},{"id":"ER","name":"Eritrea"},{"id":"EE","name":"Estonia"},{"id":"ET","name":"Ethiopia"},{"id":"FK","name":"Falkland Islands"},{"id":"FO","name":"Faroe Islands"},{"id":"FJ","name":"Fiji"},{"id":"FI","name":"Finland"},{"id":"FR","name":"France"},{"id":"GF","name":"French Guiana"},{"id":"PF","name":"French Polynesia"},{"id":"TF","name":"French Southern Territories"},{"id":"GA","name":"Gabon"},{"id":"GM","name":"Gambia"},{"id":"GE","name":"Georgia"},{"id":"DE","name":"Germany"},{"id":"GH","name":"Ghana"},{"id":"GI","name":"Gibraltar"},{"id":"GR","name":"Greece"},{"id":"GL","name":"Greenland"},{"id":"GD","name":"Grenada"},{"id":"GP","name":"Guadeloupe"},{"id":"GU","name":"Guam"},{"id":"GT","name":"Guatemala"},{"id":"GN","name":"Guinea"},{"id":"GW","name":"Guinea-Bissau"},{"id":"GY","name":"Guyana"},{"id":"HT","name":"Haiti"},{"id":"HM","name":"Heard Island and McDonald Isla"},{"id":"HN","name":"Honduras"},{"id":"HK","name":"Hong Kong"},{"id":"HU","name":"Hungary"},{"id":"IS","name":"Iceland"},{"id":"IN","name":"India"},{"id":"ID","name":"Indonesia"},{"id":"IR","name":"Iran"},{"id":"IQ","name":"Iraq"},{"id":"IE","name":"Ireland"},{"id":"IL","name":"Israel"},{"id":"IT","name":"Italy"},{"id":"CI","name":"Ivory Coast"},{"id":"JM","name":"Jamaica"},{"id":"JP","name":"Japan"},{"id":"JO","name":"Jordan"},{"id":"KZ","name":"Kazakhstan"},{"id":"KE","name":"Kenya"},{"id":"KI","name":"Kiribati"},{"id":"KW","name":"Kuwait"},{"id":"KG","name":"Kyrgyzstan"},{"id":"LA","name":"Laos"},{"id":"LV","name":"Latvia"},{"id":"LB","name":"Lebanon"},{"id":"LS","name":"Lesotho"},{"id":"LR","name":"Liberia"},{"id":"LY","name":"Libya"},{"id":"LI","name":"Liechtenstein"},{"id":"LT","name":"Lithuania"},{"id":"LU","name":"Luxembourg"},{"id":"MO","name":"Macau"},{"id":"MK","name":"Macedonia, The Former Yugoslav"},{"id":"MG","name":"Madagascar"},{"id":"MW","name":"Malawi"},{"id":"MY","name":"Malaysia"},{"id":"MV","name":"Maldives"},{"id":"ML","name":"Mali"},{"id":"MT","name":"Malta"},{"id":"MH","name":"Marshall Islands"},{"id":"MQ","name":"Martinique"},{"id":"MR","name":"Mauritania"},{"id":"MU","name":"Mauritius"},{"id":"YT","name":"Mayotte"},{"id":"MX","name":"Mexico"},{"id":"FM","name":"Micronesia"},{"id":"MD","name":"Moldova, Republic of"},{"id":"MC","name":"Monaco"},{"id":"MN","name":"Mongolia"},{"id":"MS","name":"Montserrat"},{"id":"MA","name":"Morocco"},{"id":"MZ","name":"Mozambique"},{"id":"MM","name":"Myanmar"},{"id":"NA","name":"Namibia"},{"id":"NR","name":"Nauru"},{"id":"NP","name":"Nepal"},{"id":"NL","name":"Netherlands"},{"id":"AN","name":"Netherlands Antilles"},{"id":"NC","name":"New Caledonia"},{"id":"NZ","name":"New Zealand"},{"id":"NI","name":"Nicaragua"},{"id":"NE","name":"Niger"},{"id":"NG","name":"Nigeria"},{"id":"NU","name":"Niue"},{"id":"NN","name":"None"},{"id":"NF","name":"Norfolk Island"},{"id":"KP","name":"North Korea"},{"id":"MP","name":"Northern Mariana Islands"},{"id":"NO","name":"Norway"},{"id":"OM","name":"Oman"},{"id":"PK","name":"Pakistan"},{"id":"PW","name":"Palau"},{"id":"PS","name":"Palestinian Territory, Occupie"},{"id":"PA","name":"Panama"},{"id":"PG","name":"Papua New Guinea"},{"id":"PY","name":"Paraguay"},{"id":"PE","name":"Peru"},{"id":"PH","name":"Phillippines"},{"id":"PN","name":"Pitcairn"},{"id":"PL","name":"Poland"},{"id":"PT","name":"Portugal"},{"id":"PR","name":"Puerto Rico"},{"id":"QA","name":"Qatar"},{"id":"RE","name":"Reunion"},{"id":"RO","name":"Romania"},{"id":"RU","name":"Russia"},{"id":"RW","name":"Rwanda"},{"id":"SH","name":"Saint Helena"},{"id":"KN","name":"Saint Kitts and Nevis"},{"id":"LC","name":"Saint Lucia"},{"id":"VC","name":"Saint Vincent & the Grenadines"},{"id":"WS","name":"Samoa"},{"id":"SM","name":"San Marino"},{"id":"ST","name":"Sao Tome and Principe"},{"id":"SA","name":"Saudi Arabia"},{"id":"SN","name":"Senegal"},{"id":"CS","name":"Serbia and Montenegro"},{"id":"SC","name":"Seychelles"},{"id":"SL","name":"Sierra Leone"},{"id":"SG","name":"Singapore"},{"id":"SK","name":"Slovakia"},{"id":"SI","name":"Slovenia"},{"id":"SB","name":"Solomon Islands"},{"id":"SO","name":"Somalia"},{"id":"ZA","name":"South Africa"},{"id":"GS","name":"South Georgia and the South Sa"},{"id":"KR","name":"South Korea"},{"id":"ES","name":"Spain"},{"id":"LK","name":"Sri Lanka"},{"id":"PM","name":"St. Pierre and Miquelon"},{"id":"SD","name":"Sudan"},{"id":"SR","name":"Suriname"},{"id":"SJ","name":"Svalbard and Jan Mayen"},{"id":"SZ","name":"Swaziland"},{"id":"SE","name":"Sweden"},{"id":"CH","name":"Switzerland"},{"id":"SY","name":"Syria"},{"id":"TW","name":"Taiwan"},{"id":"TJ","name":"Tajikistan"},{"id":"TZ","name":"Tanzania"},{"id":"TH","name":"Thailand"},{"id":"TL","name":"Timor-Leste"},{"id":"TG","name":"Togo"},{"id":"TK","name":"Tokelau"},{"id":"TO","name":"Tonga"},{"id":"TT","name":"Trinidad and Tobago"},{"id":"TN","name":"Tunisia"},{"id":"TR","name":"Turkey"},{"id":"TM","name":"Turkmenistan"},{"id":"TC","name":"Turks and Caicos Islands"},{"id":"TV","name":"Tuvalu"},{"id":"UG","name":"Uganda"},{"id":"UA","name":"Ukrainian SSR"},{"id":"AE","name":"United Arab Emirates (UAE)"},{"id":"GB","name":"United Kingdom"},{"id":"USA","name":"United States"},{"id":"UM","name":"United States Minor Outlying I"},{"id":"UY","name":"Uruguay"},{"id":"VI","name":"US Virgin Islands"},{"id":"UZ","name":"Uzbekistan"},{"id":"VU","name":"Vanuatu"},{"id":"VA","name":"Vatican City"},{"id":"VE","name":"Venezuela"},{"id":"VN","name":"Vietnam"},{"id":"WF","name":"Wallis and Futuna Islands"},{"id":"EH","name":"Western Sahara"},{"id":"YE","name":"Yemen"},{"id":"ZM","name":"Zambia"},{"id":"ZW","name":"Zimbabwe"}]);
    const [states] = useState([{"name":"Alabama","abbreviation":"AL"},{"name":"Alaska","abbreviation":"AK"},{"name":"Arizona","abbreviation":"AZ"},{"name":"Arkansas","abbreviation":"AR"},{"name":"California","abbreviation":"CA"},{"name":"Colorado","abbreviation":"CO"},{"name":"Connecticut","abbreviation":"CT"},{"name":"Delaware","abbreviation":"DE"},{"name":"District Of Columbia","abbreviation":"DC"},{"name":"Florida","abbreviation":"FL"},{"name":"Georgia","abbreviation":"GA"},{"name":"Hawaii","abbreviation":"HI"},{"name":"Idaho","abbreviation":"ID"},{"name":"Illinois","abbreviation":"IL"},{"name":"Indiana","abbreviation":"IN"},{"name":"Iowa","abbreviation":"IA"},{"name":"Kansas","abbreviation":"KS"},{"name":"Kentucky","abbreviation":"KY"},{"name":"Louisiana","abbreviation":"LA"},{"name":"Maine","abbreviation":"ME"},{"name":"Maryland","abbreviation":"MD"},{"name":"Massachusetts","abbreviation":"MA"},{"name":"Michigan","abbreviation":"MI"},{"name":"Minnesota","abbreviation":"MN"},{"name":"Mississippi","abbreviation":"MS"},{"name":"Missouri","abbreviation":"MO"},{"name":"Montana","abbreviation":"MT"},{"name":"Nebraska","abbreviation":"NE"},{"name":"Nevada","abbreviation":"NV"},{"name":"New Hampshire","abbreviation":"NH"},{"name":"New Jersey","abbreviation":"NJ"},{"name":"New Mexico","abbreviation":"NM"},{"name":"New York","abbreviation":"NY"},{"name":"North Carolina","abbreviation":"NC"},{"name":"North Dakota","abbreviation":"ND"},{"name":"Ohio","abbreviation":"OH"},{"name":"Oklahoma","abbreviation":"OK"},{"name":"Oregon","abbreviation":"OR"},{"name":"Pennsylvania","abbreviation":"PA"},{"name":"Rhode Island","abbreviation":"RI"},{"name":"South Carolina","abbreviation":"SC"},{"name":"South Dakota","abbreviation":"SD"},{"name":"Tennessee","abbreviation":"TN"},{"name":"Texas","abbreviation":"TX"},{"name":"Utah","abbreviation":"UT"},{"name":"Vermont","abbreviation":"VT"},{"name":"Virginia","abbreviation":"VA"},{"name":"Washington","abbreviation":"WA"},{"name":"West Virginia","abbreviation":"WV"},{"name":"Wisconsin","abbreviation":"WI"},{"name":"Wyoming","abbreviation":"WY"}]);
    const [countryId, setCountryId] = useState(model?.record.country);
    const [stateId, setStateId] = useState(model?.record.state);
    const [showStates, setShowStates] = useState(false);
    const [loading, setLoading] = useState(true);
    const [loadFailed, setLoadFailed] = useState(null);
    const { instance, accounts } = useMsal();
    const [addresses, setAddresses] = useState();
    const [addressLine2, setAddressLine2] = useState('');
    const apiProvider = new ApiProvider(instance, accounts[0]);
    
const schema = yup.object().shape({
  addressLine1: yup
    .string()
    .required('Address Line 1 is required')
    .matches(/^[a-zA-Z0-9 ]*$/, 'No special characters allowed in Address Line 1'),
  addressLine2: yup
    .string()
    .matches(/^[a-zA-Z0-9 ]*$/, 'No special characters allowed in Address Line 2'),
  city: yup.string().required('City is required'),
  country: yup.string(),
  state: yup.string().when('country', (country, schema) => {
    return country === 'US'
      ? schema.required('State is required for US addresses')
      : schema.notRequired();
  }),
    postalCode: yup
        .string()
        .required('Postal Code is required')
        .matches(/^\d{5}$/, 'Postal Code must be exactly 5 digits'),
});

    const modalSchema  = yup.object().shape({
        addressLine1: yup.string()
    });

    async function loadAddressInfo(){
        setLoading(true);
        var result = await apiProvider.Get("Profile/GetAddressInfo");
        if (!result.error){
            setModel(result);
            setLoadFailed(null);
        }
        else{
            setLoadFailed("Failed to load address information. Please try again later.");
        }
        console.debug(`addy info: ${JSON.stringify(result)}`);
        setLoading(false);
    }

    useEffect(()=>{
        loadAddressInfo();
        if(model?.record.country == "US")
            setShowStates(true);
    },[])

    const onFieldChange = (value, field) => {
        switch(field){
            case 'country':
                setCountryId(value);
                if (value == "US")
                    setShowStates(true);
                else{
                    setShowStates(true);
                    setStateId("US");
                }
                setIsDirty(true);
                break;
            case 'addressLine1':
                setIsDirty(true);
                break;
            case 'addressLine2':
                setIsDirty(true);
                break;
            case 'city':
                setIsDirty(true);
                break;
            case 'state':
                setStateId(value);
                setIsDirty(true);
                break;
            case 'postalCode':
                setIsDirty(true);
                break;
            default:
                break;
        }
        console.log("state",value, field)
    }

    const onSave = async (frmData) => {
        setLoading(true);
        const form = schema.cast(frmData);

        
            const params = new URLSearchParams({
                addressLine1: form.addressLine1,
                addressLine2: form.addressLine2, // Optional, include only if available
                city: form.city,
                state: form.state,
                postal: form.postalCode,
            });
            setAddressLine2(form.addressLine2);
            //get the likelyhood that this address exists
            var addressData = await apiProvider.Get(`Profile/GetCounty?${params.toString()}`);
            setAddresses([...addressData]);
            var addressChance = parseFloat(addressData[1]?.score);
            
            //there is an EXTREMELY high enough chance this address exists
            //has to be high so that the chance of there being more than one option or a false positive is practically impossible, otherwise we doublecheck by looking it up
            if(addressChance >= .99){
                form.addressLine1 = model.record.addressLine1 === form.addressLine1 ? null : form.addressLine1;
                form.addressLine2 = model.record.addressLine2 === form.addressLine2 ? null : form.addressLine2;
                form.city = model.record.city === form.city ? null : form.city;
                form.country = "US";
                form.state = model.record.state === form.state ? null : form.state;
                form.postalCode = model.record.postalCode === form.postalCode ? null : form.postalCode;
                form.county = addressData[1]?.county;

                await apiProvider.Patch("Profile/UpdateAddressInfo", form);

                await loadAddressInfo();
            }
            else if (addressChance >= .6){
                setShowModal(true);
            }
            else{
                setError(true);
            }  

        setLoading(false);
        setIsDirty(false);
        


    }

    const onVerificationSubmit = async (frmData) => {
        setShowModal(false);
        //get the object of the address selected
        const selectedAddress = addresses.find(obj => obj.fullAddress === frmData.selectedAddresses);
        //reformat the object to be passed through schema check
        const formattedAddress = {
            addressLine1: selectedAddress.fullAddress.match(/^(.*?),/)[1],
            addressLine2: addressLine2,
            city: selectedAddress.city,
            country: selectedAddress.countryCode,
            state: selectedAddress.state,
            postalCode: selectedAddress.postalCode
        };
        const form = schema.cast(formattedAddress);

        //format to be passed to api
        form.addressLine1 = model.record.addressLine1 === form.addressLine1 ? null : form.addressLine1;
        form.addressLine2 = model.record.addressLine2 === form.addressLine2 ? null : form.addressLine2;
        form.city = model.record.city === form.city ? null : form.city;
        form.country = form.country = "US";
        form.state = model.record.state === stateId ? null : stateId;
        form.postalCode = model.record.postalCode === form.postalCode ? null : form.postalCode;
        form.county = selectedAddress?.county;
        console.log("formatted address", form);
        await apiProvider.Patch("Profile/UpdateAddressInfo", form);

        await loadAddressInfo();
        setLoading(false);
        setIsDirty(false);
        
    }

    const handleError = (error) => {
        console.error(error);
    }

    function buildLabel(label, pending){
        return(
        pending != null ?
        <>
            <span>{label} {'\u00A0'}</span>
            { pending != null ?
                <span style={{color: 'var(--bs-purple)'}}>
                    Pending Change: {pending}
                </span>
                : ''
            }
        </>
        :
        <><span>{label}</span></>
        );
    }
    function handleErrorModal(){
        setError(false);
    }
    function onCloseModal(){
        setShowModal(false);
    }
    return (
    <>

        <div className='personalInfo-address'>
            <CdsForm schema={schema} onSubmit={(frmData)=> onSave(frmData)} onError={handleError}>
                <CdsContentPanel
                    title='Home Address'
                    primaryButtonText='Save'
                    primaryButtonSubmits={true}
                    disablePrimaryButton={!isDirty || !!model?.pending}
                >
                    {
                            loading ?
                            <Spinner show={loading}/>
                        :
                    loadFailed ? (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '150px',
                            textAlign: 'center',
                            color: '#B00020',
                            backgroundColor: '#FFF4F4',
                            borderRadius: '4px',
                            padding: '1rem',
                            fontWeight: '500'
                        }}>
                            {loadFailed}
                        </div>
                    ) : (
                        <>
                            {model?.pending && (
                                <div style={{
                                    backgroundColor: 'rgb(234, 170, 0)',
                                    color: 'black',
                                    padding: '10px',
                                    border: '1px solid rgb(234, 170, 0)',
                                    borderRadius: '4px',
                                    marginBottom: '10px',
                                }}>
                                    Your changes are pending approval.
                                </div>
                            )}
                {/* <Row>
                    <Col md={6}>
                        <CdsDropdownField 
                            label={buildLabel('Country', model?.pending?.country)}
                            name='country'
                            defaultValue={countryId}
                            value={countryId}
                            required={true}
                            optionValueField="id"
                            optionTextField="name"
                            options={countries}
                            onChange={(evt) =>{
                                onFieldChange(evt.target.value, 'country');
                            }}
                        />
                    </Col>
                </Row> */}
                <Row>
                    <Col md={6}>
                        <CdsInputField
                            label={buildLabel('Address Line 1', model?.pending?.addressLine1)}
                            name='addressLine1'
                            initialValue={model?.record.addressLine1}
                            required={true}
                            onChange={(value)=> onFieldChange(value, 'addressLine1')}
                            type='text'
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <CdsInputField
                            label={buildLabel('Address Line 2', model?.pending?.addressLine2)}
                            name='addressLine2'
                            initialValue={model?.record.addressLine2}
                            required={false}
                            type='text'
                            onChange={(value)=> onFieldChange(value, 'addressLine2')}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <CdsInputField
                            label={buildLabel('City', model?.pending?.city)}
                            name='city'
                            initialValue={model?.record.city}
                            required={true}
                            type='text'
                            onChange={(value)=> onFieldChange(value, 'city')}
                        />
                    </Col>
                    <Col md={4}>
                        <CdsDropdownField
                            label={buildLabel('State', model?.pending?.state)}
                            name='state'
                            defaultValue={stateId}
                            required={true}
                            optionValueField="abbreviation"
                            optionTextField="name"
                            onChange={(evt) =>{
                                onFieldChange(evt.target.value, 'state');
                            }}
                            options={states}
                        />
                        {/* {showStates ?
                            <CdsDropdownField
                            label={buildLabel('State', model?.pending?.state)}
                            name='state'
                            defaultValue={stateId}
                            required={true}
                            optionValueField="abbreviation"
                            optionTextField="name"
                            onChange={(evt) =>{
                                onFieldChange(evt.target.value, 'state');
                            }}
                            options={states}
                            />
                        : <></>
                            // <CdsInputField
                            //     label={buildLabel('Region', model?.pending?.region)}
                            //     name='region'
                            //     initialValue={model?.record?.region}
                            //     required={true}
                            //     type='text'
                            //     onChange={(value)=> onFieldChange(value, 'state')}
                            // />
                        } */}
                    </Col>
                    <Col md={4}>
                        <CdsInputField
                            label={buildLabel('Postal Code', model?.pending?.postalCode)}
                            name='postalCode'
                            initialValue={model?.record.postalCode}
                            required={true}
                            type='text'
                            onChange={(value)=> onFieldChange(value, 'postalCode')}
                        />
                    </Col>
                </Row>
                </>
                )}
                </CdsContentPanel>
                
            </CdsForm>
            <CdsFormModal title={`Please select your address`}
                disablePrimaryButton={false}
                show={showModal}  
                schema={modalSchema} 
                onSubmit={onVerificationSubmit}
                handleCloseClick={onCloseModal}
            >
                <AddressValidationModal model={addresses} addressLine2={addressLine2} />
            </CdsFormModal>
            <CdsErrorModal show={error} handleCloseClick={handleErrorModal} text="We couldn't find the address entered!"></CdsErrorModal>
        </div>
    </>
    );
}

export default Address;